<template>
  <div ref="container" style="display: block;width: 100%;height: 100%;position: relative">
    <slot></slot>
  </div>
</template>


<script>
  import Vue from 'vue'
  import LineChart from './linechart'

  export default {
    name: "line-chart",
    props: {
      data: {
        type: Array,
        default: () => ([])
      },
      option: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        defOption: {
          margin: {
            left: 60,
            right: 20,
            top: 20,
            bottom: 20
          },
          axisLabels: {
            x: "Axis X",
            y: "Axis Y"
          },
          reverse: false,
          axisData: {
            x: {
              type: "date",
              tickFormat: "DD.MM"
            }
          },
          xAxis: "x"
        }
      }
    },

    mounted() {
      this.updateChart();
      window.addEventListener('resize', this.updateChart);
    },

    computed: {
      validData() {
        if (!this.data || this.data.length < 3) return [];
        let validatedData = JSON.parse(JSON.stringify(this.data));

        const xAxis = this.option.xAxis || this.defOption.xAxis;

        validatedData.sort((v1, v2) => v1[xAxis] - v2[xAxis]);

        const y = (x1, x2, y1, y2, x) => (x - x1) / (x2 - x1) * (y2 - y1) + y1;

        for (let p in validatedData[0]) {

          if (!validatedData[0].hasOwnProperty(p) || p === xAxis) continue;

          const values = validatedData.map(v => ({[xAxis]: v[xAxis], [p]: v[p]})).filter(v => v[p] !== null);

          let j = 0;

          for (let i = 1; i < validatedData.length - 1; i++) {
            const currentValues = validatedData[i];

            if (currentValues[p] !== null) {
              j++;
              continue;
            }

            if (j >= values.length - 1) continue;

            const x1 = values[j][xAxis];
            const y1 = values[j][p];

            const x2 = values[j + 1][xAxis];
            const y2 = values[j + 1][p];

            const x = currentValues[xAxis];

            currentValues[p] = y(x1, x2, y1, y2, x);

          }
        }

        return validatedData;
      }
    }
    ,
    methods: {
      updateChart() {
        const options = {
          width: this.$refs.container.clientWidth,
          height: this.$refs.container.clientHeight,
          container: this.$refs.container
        };

        for (let i in this.option)
          if (this.option.hasOwnProperty(i) && 'undefined' !== typeof this.option[i])
            options[i] = this.option[i];

        for (let i in this.defOption)
          if (this.defOption.hasOwnProperty(i) && 'undefined' !== typeof this.defOption[i] && 'undefined' === typeof options[i])
            options[i] = this.defOption[i];

        LineChart(this.validData, options);
      }
    },

    components: {},

    watch: {
      data() {
        this.updateChart();
      },
      option() {
        this.updateChart();
      }
    }
  }
</script>

<style>

</style>
